import React, { useEffect, Fragment, useState } from "react";
import { getStores } from '../services';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Leftnav from '../components/Leftnav';
import Pagetitle from '../components/Pagetitle';
import Appfooter from '../components/Appfooter';
import Popupchat from '../components/Popupchat';
import Load from '../components/Load';
import { posts } from '../services/dummy-data';

const Badge = ()=>  {
        const [stores, setStores] = useState([]);
        const fetch = async () => {
            const theStores = await getStores();
            setStores(theStores.data)
        }
        useEffect(() => {
            fetch();
        },[])
        return (
            <Fragment> 
                <Header />
                <Leftnav />
                <div className="main-content right-chat-active">
                    <div className="middle-sidebar-bottom">
                        <div className="middle-sidebar-left pe-0">
                            <div className="row">
                                <div className="col-xl-12">
                                    <Pagetitle title="Marcas..."/>
                                    <div className="row ps-2 pe-1">
                                        {process.env.REACT_APP_STAGE === 'DEV' && 
                                        posts.map((value , index) => (
                                        <div key={index} className="col-md-6 col-sm-6 pe-2 ps-2">
                                            <div className="card d-block border-0 shadow-xss rounded-3 overflow-hidden mb-0 mt-2">
                                                <div className="card-body position-relative h100 bg-image-cover bg-image-center" style={{backgroundImage: `url("${value.image}")`}}></div>
                                                <div className="card-body d-block w-100 pl-10 pe-4 pb-4 pt-0 text-left position-relative">
                                                    <figure className="avatar position-absolute w75 z-index-1 left-15" style={{marginTop: `-40px` }}><img src={`${value.owner.picture}`} alt="avater" className="float-right p-1 bg-white rounded-circle w-100 " /></figure>
                                                    <div className="clearfix"></div>
                                                    <h4 className="fw-700 font-xsss mt-3 mb-1">{value.owner.name}</h4>
                                                    <p className="fw-500 font-xsssss text-grey-500 mt-0 mb-3 lh-3">{value.owner.email}</p>
                                                    <span className="position-absolute right-15 top-0 d-flex align-items-center">
                                                        <a href="/defaultgroup" className="text-center p-2 lh-24 w100 ms-1 ls-3 d-inline-block rounded-xl bg-current font-xsssss fw-700 ls-lg text-white">Seguir</a>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        ))}
                                        {stores.map((value , index) => (
                                        <Link to={`/grouppage?id=${value._id}`} key={index} className="col-md-6 col-sm-6 pe-2 ps-2">
                                            <div className="card d-block border-0 shadow-xss rounded-3 overflow-hidden mb-0 mt-2">
                                                <div className="card-body position-relative h100 bg-image-cover bg-image-center" style={{backgroundImage: `url("${value.banner ? value.banner.url : 'https://logos-marcas.com/wp-content/uploads/2020/04/Huawei-Logo.png'}")`}}></div>
                                                <div className="card-body d-block w-100 pl-10 pe-4 pb-4 pt-0 text-left position-relative">
                                                    <figure className="avatar position-absolute w75 z-index-1 left-15" style={{marginTop: `-40px` }}><img src={`${value.banner ? value.banner.url : 'https://logos-marcas.com/wp-content/uploads/2020/04/Huawei-Logo.png'}`} alt="avater" className="float-right p-1 bg-white rounded-circle w-100 " /></figure>
                                                    <div className="clearfix"></div>
                                                    <h4 className="fw-700 font-xsss mt-3 mb-1">{value.name}</h4>
                                                    <p className="fw-500 font-xsssss text-grey-500 mt-0 mb-3 lh-3">{value.mail}</p>
                                                    <span className="position-absolute right-15 top-0 d-flex align-items-center">
                                                        <a href="/defaultgroup" className="text-center p-2 lh-24 w100 ms-1 ls-3 d-inline-block rounded-xl bg-current font-xsssss fw-700 ls-lg text-white">Seguir</a>
                                                    </span>
                                                </div>
                                            </div>
                                        </Link>
                                        ))}
                                        <Load />
                                    </div>
                                </div>               
                            </div>
                        </div>
                    </div>
                </div>
                <Popupchat />
                <Appfooter /> 
            </Fragment>
        );
}

export default Badge;